import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function TableListHeaderItem(props) {
  const {
    columnDef: {
      width: columnWidth,
      hAlign
    },
    item,
    children
  } = props;
  const width = typeof columnWidth === 'number' ? columnWidth : null;
  const [minWidth, maxWidth] = Array.isArray(columnWidth) ? columnWidth : [columnWidth, columnWidth];
  const fluid = minWidth ? 1 : null;
  const justifyContent = hAlign === 'end' ? 'flex-end' : 'flex-start';
  return /*#__PURE__*/_jsx("div", {
    "data-testid": props['data-testid'],
    className: item.className,
    style: {
      display: 'flex',
      justifyContent,
      width,
      minWidth,
      maxWidth,
      flex: fluid
    },
    children: children || item.value
  });
}